<script setup lang="ts">
import { onBeforeUnmount, onMounted, type PropType } from 'vue'
import { VIcons } from '@/shared/ui'

defineProps({
  items: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
})

const emits = defineEmits(['clear', 'allSelect'])

/**
 * Функция очистки списка выделенных объектов
 * @param event
 */
const clearList = (event: KeyboardEvent) => {
  if (event.key === 'Escape') emits('clear')
}

/**
 * Функция выбора всех дочерних элементов
 */
const allSelectWithChild = () => {
  emits('allSelect')
}

/* Назначаем прослушивателя событий */
onMounted(() => {
  document.addEventListener('keyup', clearList)
})

/* Удаляем прослушивателя событий */
onBeforeUnmount(() => {
  document.removeEventListener('keyup', clearList)
})
</script>

<template>
  <VExpansionPanel v-if="items.length" density="compact" :min-width="300" :max-width="500">
    <template #title>
      <div class="w-invent-map-info-item__header">
        <div class="w-invent-map-info-item__title">
          <VIcons type="stack" class="w-invent-map-info-item__icon_default" />

          {{ $t('itf.selected_objects_count', { count: items.length }) }}
        </div>

        <VTooltip location="top" :open-delay="1000" :text="$t('itf.clear_selected')">
          <template #activator="{ props }">
            <VBtn
              icon
              density="compact"
              color="error"
              variant="plain"
              v-bind="props"
              @click.stop="emits('clear')"
            >
              <VIcons type="mop" />
            </VBtn>
          </template>
        </VTooltip>
      </div>
    </template>

    <template #text>
      <div class="control_compact control_compact_left">
        <VBtn density="comfortable" @click="allSelectWithChild">
          {{ $t('itf.all_elements_children') }}
        </VBtn>
      </div>
    </template>
  </VExpansionPanel>
</template>
